"use client";

import styled from "styled-components";
import Icon from "@/components/icon";

export const BoxSelect = styled.div<{ $disabled?: boolean }>`
  border: 1px solid var(--borderColor);
  border-radius: 7px;
  position: relative;
  height: 40px;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
`;

export const SelectComponent = styled.select`
  height: 40px;
  width: 100%;
  box-shadow: none;
  padding: 5px 30px 5px 10px;
  font-size: 14px;
  font-weight: normal;
  font-family: "Outfit", sans-serif;
  color: var(--colorTitle);
  border-radius: 7px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: var(--grayCard);
  }
`;

export const IconComponent = styled(Icon)`
  position: absolute;
  top: 50%;
  margin-top: -3.5px;
  right: 12px;
  z-index: 0;

  svg {
    fill: var(--colorTitle);
    path {
      fill: transparent;
      stroke: var(--colorTitle);
    }
  }
`;

export const OptionsList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background: var(--backgroundColorCard);
  border: 1px solid var(--borderColor);
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 0 0 7px 7px;
`;

export const OptionItem = styled.li<{
  $isSelected?: boolean;
  $isDisabled?: boolean;
}>`
  padding: 10px;
  font-size: 14px;
  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
  background-color: ${({ $isSelected }) =>
    $isSelected ? "var(--primarySystem)" : "var(--backgroundColorCard)"};
  color: ${({ $isDisabled }) => ($isDisabled ? "#999" : "var(--colorTitle)")};
  font-style: ${({ $isDisabled }) => ($isDisabled ? "italic" : "normal")};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? "none" : "auto")};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--primarySystem);
    color: var(--colorTitle);
  }
`;

export const GroupHeader = styled.li`
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 600;
  color: var(--colorTitle);
  background-color: var(--borderGraySearch);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid var(--borderColor);
  cursor: default;
  pointer-events: none;
  position: sticky;
  top: 0;
  z-index: 1;
`;
